import { render, staticRenderFns } from "./centre.vue?vue&type=template&id=e0f8c9c4&scoped=true"
import script from "./centre.vue?vue&type=script&lang=js"
export * from "./centre.vue?vue&type=script&lang=js"
import style0 from "./centre.vue?vue&type=style&index=0&id=e0f8c9c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f8c9c4",
  null
  
)

export default component.exports